export const authResources = {
  "zh-CN": {
    auth: {
      logoAlt: "Tubo 智能体工作台",
      loginMethod: "登录方式",
      companyName: "图博数智 inFab",
      copyright: "© {{year}} {{company}}。版权所有。",
      registerForm: {
        title: "注册",
        setPasswordTitle: "设置密码",
        createAccountDescription: "创建您的账号以开始使用",
        setPasswordDescription: "设置您的登录密码，下次可直接登录",
        existingAccount: "已有账号？",
        login: "登录",
        nameLabel: "姓名",
        namePlaceholder: "请输入姓名",
        phoneLabel: "手机号",
        phonePlaceholder: "请输入手机号",
        verificationCodeLabel: "验证码",
        verificationCodePlaceholder: "请输入验证码",
        getVerificationCode: "获取验证码",
        organizationLabel: "组织名称",
        organizationPlaceholder: "请选择或输入组织名称",
        organizationNoMatch: "无匹配的组织名称",
        passwordLabel: "密码",
        passwordPlaceholder: "请输入密码（至少 6 位）",
        confirmPasswordLabel: "确认密码",
        confirmPasswordPlaceholder: "请再次输入密码",
        startPrivateBeta: "开启专属内测",
        enterSystem: "进入系统",
        chooseOrganization: "请选择组织后继续",
        registrationFailed: "注册失败，请稍后重试",
        setPasswordFailed: "设置密码失败，请稍后重试",
        sendSmsFailed: "发送短信失败",
        passwordVisibilityShow: "显示密码",
        passwordVisibilityHide: "隐藏密码",
        captchaTitle: "请完成滑块验证",
        captchaExpired: "验证码已过期",
      },
      validation: {
        loginNameRequired: "请输入用户名/邮箱/手机号",
        passwordRequired: "请输入密码",
        nameRequired: "请输入姓名",
        nameTooLong: "姓名不能超过 50 个字符",
        phoneRequired: "请输入手机号",
        phoneInvalid: "手机号格式不正确",
        organizationRequired: "请选择组织名称",
        organizationTooLong: "组织名称不能超过 50 个字符",
        passwordTooShort: "密码至少 6 个字符",
        confirmPasswordRequired: "请确认密码",
        passwordsMismatch: "两次密码不一致",
        verificationCodeRequired: "请输入验证码",
        verificationCodeLength: "验证码为 4 位数字",
      },
    },
  },
  "en-US": {
    auth: {
      logoAlt: "Tubo Agent Workbench",
      loginMethod: "Sign-in method",
      companyName: "TuboData inFab",
      copyright: "© {{year}} {{company}}. All rights reserved.",
      registerForm: {
        title: "Create an account",
        setPasswordTitle: "Set a password",
        createAccountDescription: "Create your account to get started.",
        setPasswordDescription: "Set a password to sign in directly next time.",
        existingAccount: "Already have an account?",
        login: "Sign in",
        nameLabel: "Name",
        namePlaceholder: "Enter your name",
        phoneLabel: "Phone number",
        phonePlaceholder: "Enter your phone number",
        verificationCodeLabel: "Verification code",
        verificationCodePlaceholder: "Enter the verification code",
        getVerificationCode: "Get code",
        organizationLabel: "Organization",
        organizationPlaceholder: "Choose or enter an organization",
        organizationNoMatch: "No matching organizations",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter a password (at least 6 characters)",
        confirmPasswordLabel: "Confirm password",
        confirmPasswordPlaceholder: "Re-enter your password",
        startPrivateBeta: "Start your private beta",
        enterSystem: "Continue",
        chooseOrganization: "Choose an organization to continue.",
        registrationFailed: "Could not register. Please try again later.",
        setPasswordFailed: "Could not set the password. Please try again later.",
        sendSmsFailed: "Could not send the SMS.",
        passwordVisibilityShow: "Show password",
        passwordVisibilityHide: "Hide password",
        captchaTitle: "Complete the slider verification",
        captchaExpired: "The verification challenge has expired.",
      },
      validation: {
        loginNameRequired: "Enter your username, email, or phone number.",
        passwordRequired: "Enter your password.",
        nameRequired: "Enter your name.",
        nameTooLong: "Name must be 50 characters or fewer.",
        phoneRequired: "Enter your phone number.",
        phoneInvalid: "Enter a valid phone number.",
        organizationRequired: "Choose an organization.",
        organizationTooLong: "Organization name must be 50 characters or fewer.",
        passwordTooShort: "Password must be at least 6 characters.",
        confirmPasswordRequired: "Confirm your password.",
        passwordsMismatch: "The passwords do not match.",
        verificationCodeRequired: "Enter the verification code.",
        verificationCodeLength: "The verification code must contain 4 digits.",
      },
    },
  },
} as const;
